import { render } from "./ComHeader.vue?vue&type=template&id=1563676e&scoped=true"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"

import "./ComHeader.vue?vue&type=style&index=0&id=1563676e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1563676e"]])

export default __exports__